import React, { forwardRef } from 'react';
import type { HTMLProps } from '../factory';
import { useRecoilValue } from 'recoil';
import { blockFonts, getCustomFontSize } from 'venn-state';

export type BlockFooterElement = React.ElementRef<'div'>;
export interface BlockFooterProps extends HTMLProps<'div'> {
  children: React.ReactNode;
  id: string;
}

export const BlockFooter = forwardRef<BlockFooterElement, BlockFooterProps>((props, ref) => {
  const { children, id } = props;
  const tableFont = useRecoilValue(blockFonts.blockTableData(id));
  const fontSize = getCustomFontSize(tableFont);

  return (
    <div
      ref={ref}
      style={{ fontSize }}
      className="text-venn-grey-80 px-[8px] py-[6px] border-0 border-t border-solid border-t-venn-grey-30 flex-1"
    >
      {children}
    </div>
  );
});

BlockFooter.displayName = 'BlockFooter';
